import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Images } from '../../../@resources/img';
import { Grid } from '../../../ui';
import { Avatar } from '../../common/Avatar';
import { useResolve } from '../../Container';
import { Flexer, TextArea } from '../../dashboard/elements/LayoutElements';
import { ProfileModel } from '../../ProfileModel';

const Icon = styled.div<{ color?: string }>`
    position: absolute;
    top: 0;
    left: 0;
    padding: .375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${p => p.color ?? 'none'};
    color: white;
    border-radius: 0.5rem;
`;

const Actions = styled.div`
    display: flex;
    gap: 1rem;
`;

const Base = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-right: 1rem;
`;

const Actor = styled.div``;

const Message = ({ overflow, actor, children }: { overflow?: string, actor: ReactNode, children: ReactNode }) => {
    return <Flexer padding=".5 0" >
        <Grid columns="3rem 1fr" columnGap="1">
            <Actor>{actor}</Actor>
            <Flexer overflow={overflow}>
                {children}
            </Flexer>
        </Grid>
    </Flexer>;
};

const Seb = () => {
    return <Flexer>
        <img src={Images.SebBlue} />
    </Flexer>;
};

const You = () => {
    const me = useResolve(ProfileModel);
    return <Avatar.ForUser user={me} />;
};

const Input = styled(TextArea)`
    width: 100%;
    height: 6rem;
`;

export const Chat = Object.assign(Base, {
    Icon,
    Message,
    Input,
    Actions,
    Seb,
    You,
});
